/**
 * LoginPage — thin CTI wrapper around the SHARED login page.
 *
 * All login UI/behavior lives in lib/auth/SharedLoginPage (the kit component,
 * identical across every app). This file only:
 *   - handles the "already logged in" redirect,
 *   - supplies CTI branding (title, logo, accent),
 *   - wires CTI's AuthProvider (login / completeNewPassword) into the shared page.
 */

import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../components/AuthProvider';
import { ThemeToggle } from '../components/ThemeToggle';
import SharedLoginPage from '../lib/auth/SharedLoginPage';
import config from '../config/app.config';

export function LoginPage() {
  const { login, completeNewPassword, isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  // Redirect if already logged in (but wait for session check).
  if (!isLoading && isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  // While checking session, show nothing (prevents flash).
  if (isLoading) {
    return null;
  }

  return (
    <div className="relative">
      <div className="absolute top-4 right-4 z-10">
        <ThemeToggle />
      </div>
      <SharedLoginPage
        login={login}
        completeNewPassword={completeNewPassword}
        onAuthenticated={() => navigate('/', { replace: true })}
        appName={config.companyName}
        subtitle={config.appName}
        logoText="CTI"
        accentColor="#14b8a6"
        usernameLabel="Username or Email"
        usernamePlaceholder="e.g. you@example.com"
        footerText="Privacy-Preserving CTI System · Powered by AWS"
      />
    </div>
  );
}
